import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { Subject } from 'rxjs';
import { UtilityService } from '../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ApprovalMatrixService } from '../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../Util/Session/session.service';
import moment from 'moment';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { ReimbursementformService } from '../../Model/Reimbursement/reimbursementform.service';
import { ThumbnailAttachmentComponent } from '../../Component/thumbnail-attachment/thumbnail-attachment.component';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ApprovalMatrixViewComponent } from '../../approval-matrix-view/approval-matrix-view.component';

@Component({
  selector: 'app-claimed-reimbursement',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDatepickerModule, DataTablesModule, RouterModule, LoaderComponent, ThumbnailAttachmentComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './claimed-reimbursement.component.html',
  styleUrl: './claimed-reimbursement.component.scss'
})
export class ClaimedReimbursementComponent {
  isDisabled: boolean = false;
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  user = [] as any;
  Filter = {
    SelectType: '1',
    EmpMasterId: 0,
    ApprovalStatus: 'ALL',
    Remark: null,
    ESS_ReimbursementRequestId: null,
    ESS_ReimbursementTypeId: null as any,
    OutstandingAmount: null,
    BillAmount: null,
    ClaimedAmount: null,
    MonthYear: '',
    selectedMonth: null as any,
    selectedYear: '',
    Attachment: '',
    IsCheckedbox: false,
    EmpType: 'front'
  }
  selectedMonth: any = null;
  MainDatas = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private reimbursement: ReimbursementformService,
    protected common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private utility: UtilityService,
    private dateFromat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    //this.Filter.EmpMasterId = this.user.UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ReimbursementLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_ReimbursementLoad();
    } else {
      form.submitted = true;
    }
  }

  ESS_ReimbursementLoad() {
    this.Filter.SelectType = '1';
    this.Filter.MonthYear = this.Filter.IsCheckedbox ? this.Filter.MonthYear : '';
    this.isDisabled = true
    this.reimbursement.ESS_ReimbursementRequest_Load(this.Filter).subscribe({
      next: (data) => {
        this.MainDatas = data.Table;
        this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
  }
  Clear() {
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  onNavigate() {
    const startFromDate = new Date(this.selectedMonth.year, this.selectedMonth.month - 1, 1);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long' };
    this.Filter.MonthYear = startFromDate.toLocaleDateString('en-GB', options);
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'Reimbursement' + '/' + Text;
  }

  FilterEmpType(type: string) {
    this.Filter.EmpType = type;
    this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  ExcelDump() {
    if (this.TableDatas.length == 0) {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    } else {
      this.download.exportToExcelWithProgress(this.TableDatas, 'Reimbursement History')
    }
  }

  viewApprovalMatrix(i: number) {
    const modalRef = this.modalService.open(ApprovalMatrixViewComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.TransactionId = this.TableDatas[i]['ESS_ReimbursementRequestId'];
    modalRef.componentInstance.EmployeeId = this.TableDatas[i]['EmpMasterId'];
    modalRef.componentInstance.RequestDate = this.TableDatas[i]['RequestDate'];
    modalRef.componentInstance.ApprovalStatus = this.TableDatas[i]['ApprovalStatus'];
    modalRef.componentInstance.ModuleMasterId = 16;
  }
}
